// FeaturesArNXT.jsx
import React from "react";
import {
  Box,
  Grid,
  Card,
  CardContent,
  Typography,
  IconButton,
} from "@mui/material";

// Import MUI icons
import ViewInArIcon from "@mui/icons-material/ViewInAr";
import WallpaperIcon from "@mui/icons-material/Wallpaper";
import GridViewIcon from "@mui/icons-material/GridView";
import WeekendIcon from "@mui/icons-material/Weekend";
import ChairIcon from "@mui/icons-material/Chair";
import ApiIcon from "@mui/icons-material/Api";
import TextureIcon from "@mui/icons-material/Texture";


const FeaturesArNXT = () => {
  const features = [
    {
      Icon: ViewInArIcon,
      title: "AR & 3D Viewer",
      desc: "View 3D models and AR previews in real-world scale directly from the browser.",
    },
    {
      Icon: WallpaperIcon,
      title: "Wall Visualizer",
      desc: "Apply paints & wallpapers and preview changes on room walls.",
    },
    {
      Icon: GridViewIcon,
      title: "Floor Visualizer",
      desc: "Experiment with floor materials, tiles and layouts with instant preview.",
    },
   {
  Icon: TextureIcon,
  title: "Rugs & Carpet Visualizer",
  desc: "Try rugs and carpets in your room to check fit, color, and style instantly.",
},

    {
      Icon: ChairIcon,
      title: "Upholstery",
      desc: "Swap upholstery fabrics and textures on Sofa to explore different looks.",
    },
    {
      Icon: ApiIcon,
      title: "API Integration",
      desc: "Integrate the visualizer tools — AR, Wall, Floor, Rugs, and Upholstery — into your own platform securely via APIs.",
    },
  ];

  return (
    <Box sx={{ pt: 8, bgcolor: "#ffffff" }}>
      {/* Heading */}
      <Box textAlign="center" mb={6} px={2}>
        <Typography
          variant="h4"
          sx={{
            fontWeight: 700,
            color: "#012A38",
            letterSpacing: "-0.5px",
            fontSize: { xs: "1.6rem", sm: "2rem", md: "2.4rem" },
          }}
        >
          What ArNXT can do
        </Typography>

        <Typography
          variant="body2"
          sx={{
            mt: 1,
            color: "text.secondary",
            maxWidth: 720,
            mx: "auto",
            fontSize: { xs: "0.9rem", sm: "1rem" },
          }}
        >
          Explore AR, 3D viewing and visualizers for walls, floors, rugs and furniture.
          Easily integrate with your APIs and product catalogs.
        </Typography>
      </Box>

      {/* Grid */}
      <Box sx={{ maxWidth: 1200, mx: "auto", px: 3 }}>
        <Grid container spacing={4} justifyContent="center">
          {features.map((f, idx) => {
            const Icon = f.Icon;
            return (
              <Grid
                item
                key={idx}
                xs={12}
                sm={6}
                md={4}
                lg={3}
                sx={{ display: "flex", justifyContent: "center" }}
              >
                <Card
                  elevation={0}
                  sx={{
                    width: "100%",
                    maxWidth: 300,
                    textAlign: "center",
                    p: 2.5,
                    borderRadius: 2,
                    border: "1px solid",
                    borderColor: "divider",
                    transition: "transform 0.24s ease, box-shadow 0.24s ease",
                    "&:hover": {
                      transform: "translateY(-6px)",
                      boxShadow: 6,
                    },
                  }}
                >
                  <CardContent sx={{ p: 0 }}>
                    <Box
                      sx={{
                        width: 72,
                        height: 72,
                        mx: "auto",
                        mb: 2,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        bgcolor: "background.paper",
                        borderRadius: "50%",
                        border: "1px solid",
                        borderColor: "divider",
                      }}
                    >
                      <Icon sx={{ fontSize: 36 }} />
                    </Box>

                    <Typography
                      variant="h6"
                      sx={{
                        fontWeight: 600,
                        mb: 1,
                        fontSize: { xs: "1rem", sm: "1.05rem" },
                      }}
                    >
                      {f.title}
                    </Typography>

                    <Typography
                      variant="body2"
                      sx={{ color: "text.secondary", lineHeight: 1.6 }}
                    >
                      {f.desc}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            );
          })}
        </Grid>
      </Box>
       <Box
  mt={3}
  sx={{
    backgroundColor: "#0a536dff",
    color: "#fff",
    px: 3,
      py: 2,
      display: "flex",
      justifyContent:"center",
    fontSize: "15px",
    width:"97vw",
  }}
>
  Start your free trial to experience 3D product visualisation.
</Box>
    </Box>
  );
};

export default FeaturesArNXT;
